import React from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import { Box, Tabs, Tab } from '@mui/material';
import SearchReport from './Search';
import DailyReport from './Daily';
import ReasonsReport from './Reasons';
import StaffReport from './Staff';
import WaitTimesReport from './WaitTimes';
import ExportReport from './Export';
import StatisticsReport from './Statistics';

const tabs = [
  { label: 'Search', path: '/reports/search' },
  { label: 'Daily', path: '/reports/daily' },
  { label: 'Reasons', path: '/reports/reasons' },
  { label: 'Staff', path: '/reports/staff' },
  { label: 'Wait Times', path: '/reports/wait-times' },
  { label: 'Statistics', path: '/reports/statistics' },
  { label: 'Export', path: '/reports/export' },
];

const Reports = ({ access }) => {
  const location = useLocation();
  const currentTab = tabs.findIndex(t => location.pathname.startsWith(t.path));

  return (
    <Box>
      <Tabs value={currentTab === -1 ? 0 : currentTab} sx={{ mb: 3 }}>
        {tabs.map(t => <Tab key={t.path} label={t.label} component={Link} to={t.path} />)}
      </Tabs>
      <Routes>
        <Route path="/search" element={<SearchReport access={access} />} />
        <Route path="/daily" element={<DailyReport access={access} />} />
        <Route path="/reasons" element={<ReasonsReport access={access} />} />
        <Route path="/staff" element={<StaffReport access={access} />} />
        <Route path="/wait-times" element={<WaitTimesReport access={access} />} />
        <Route path="/statistics" element={<StatisticsReport access={access} />} />
        <Route path="/export" element={<ExportReport access={access} />} />
        <Route path="*" element={<SearchReport access={access} />} />
      </Routes>
    </Box>
  );
};

export default Reports;
